import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import React from 'react';
const SegmentedPickerButton = _ref => {
  let onClick = _ref.onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    isDisabled = _ref.isDisabled,
    width = _ref.width,
    value = _ref.value,
    children = _ref.children;
  const handleClick = event => onClick(value, event.target.value);
  return /*#__PURE__*/React.createElement(Button, {
    className: className,
    onClick: handleClick,
    disabled: isDisabled,
    style: {
      width: "".concat(width, "%")
    }
  }, children);
};
SegmentedPickerButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
  width: PropTypes.number.isRequired
};
export default SegmentedPickerButton;